// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  background: rgba(16, 16, 16, 0.8);
  inset: 0;
  z-index: 40;
}
.modal .modal-container {
  background: #FDFDFD;
  border-radius: 12px;
  z-index: 50;
}
.modal .modal-container .modal-content {
  overflow: auto;
}
.modal .modal-container.extra-large .modal-header {
  padding: 10px;
}
.modal .modal-container.large {
  width: 832px;
  height: 640px;
}
.modal .modal-container.large .modal-header,
.modal .modal-container.large .modal-footer,
.modal .modal-container.large .modal-content {
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.modal .modal-container.large .modal-header {
  border-bottom: 1px solid #F3F3F3;
}
.modal .modal-container.large .modal-footer {
  border-top: 1px solid #F3F3F3;
  justify-content: flex-end;
  gap: 1rem;
}
.modal .modal-container.medium {
  width: 560px;
  height: 684px;
}
.modal .modal-container.medium .modal-content {
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 2rem;
  padding-bottom: 1.25rem;
}
.modal .modal-container.medium .modal-header,
.modal .modal-container.medium .modal-footer {
  gap: 1rem;
  padding: 2rem;
}
.modal .modal-container.medium .modal-header button,
.modal .modal-container.medium .modal-footer button {
  flex: 1;
}
.modal .modal-container.medium .modal-header {
  border-bottom: 1px solid #F3F3F3;
}
.modal .modal-container.medium .modal-footer {
  border-top: 1px solid #F3F3F3;
}
.modal .modal-container.regular {
  width: 380px;
  height: 442px;
}
.modal .modal-container.regular .modal-content {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
  padding-bottom: 1.25rem;
}
.modal .modal-container.regular .modal-header,
.modal .modal-container.regular .modal-footer {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 1.5rem;
  gap: 0.5rem;
}
.modal .modal-container.regular .modal-header button,
.modal .modal-container.regular .modal-footer button {
  width: 100%;
}
.modal .modal-container.regular .modal-header {
  padding-top: 1.5rem;
}
.modal .modal-container.regular .modal-footer {
  flex-direction: column-reverse;
}
.modal .modal-container.qrcode {
  width: 640px;
  height: 532px;
}
.modal .modal-container.qrcode .modal-content {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
  padding-bottom: 1.25rem;
}
.modal .modal-container.qrcode .modal-header,
.modal .modal-container.qrcode .modal-footer {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 1.5rem;
  gap: 0.5rem;
}
.modal .modal-container.qrcode .modal-header button,
.modal .modal-container.qrcode .modal-footer button {
  width: 100%;
}
.modal .modal-container.qrcode .modal-header {
  padding-top: 1.5rem;
}
.modal .modal-container.qrcode .modal-footer {
  flex-direction: column-reverse;
}

@media (max-width: 768px) {
  /* Center modal on mobile with space around and rounded corners
     Force a max width and max height so it never becomes full-bleed. */
  .modal {
    display: flex !important;
    align-items: center !important;
    justify-content: center;
    padding: 20px !important; /* space around modal */
    background: rgba(16, 16, 16, 0.6);
  }
  .modal .modal-container {
    width: calc(100% - 40px) !important;
    max-width: 640px !important;
    max-height: calc(100vh - 80px) !important;
    height: auto !important;
    margin: 0 auto !important;
    border-radius: 12px !important;
    overflow: auto !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  }
  /* Ensure modal header/footer and content fit inside the new constraints */
  .modal .modal-content {
    max-height: calc(100vh - 160px) !important;
    overflow-y: auto !important;
  }
}
/* Reduce internal padding on mobile modals to create a tighter, cleaner layout */
@media (max-width: 768px) {
  .modal .modal-container {
    /* If content wrapper divs set padding elsewhere, ensure smaller padding here too */
    /* Make footer sticky to avoid overlapping content when content scrolls */
  }
  .modal .modal-container .modal-header,
  .modal .modal-container .modal-footer {
    padding: 12px !important;
  }
  .modal .modal-container .modal-content {
    padding: 8px !important;
    /* reserve space for sticky footer */
    padding-bottom: 96px !important;
  }
  .modal .modal-container .modal-content > div {
    padding: 12px !important;
    box-sizing: border-box !important;
  }
  .modal .modal-container .modal-footer {
    position: sticky !important;
    bottom: 0 !important;
    left: 0 !important;
    width: 100% !important;
    background: #FDFDFD !important;
    z-index: 60 !important;
    box-shadow: 0 -6px 16px rgba(0, 0, 0, 0.06) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modal/style.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,QAAA;EACA,WAAA;AACF;AACE;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;AACJ;AACI;EACE,cAAA;AACN;AAGM;EACE,aAAA;AADR;AAKI;EACE,YAAA;EACA,aAAA;AAHN;AAQQ;;;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA;AAAA;AAGF;EACE,gCAAA;AAJR;AAOM;EACE,6BAAA;EAEA,yBAAA;EAAA,SAAA;AANR;AAUI;EACE,YAAA;EACA,aAAA;AARN;AAWQ;EAAA,kBAAA;EAAA,mBAAA;EAAA,iBAAA;EAAA;AAAA;AAKA;;EAAA,SAAA;EACA;AADA;AAGA;;EACE,OAAA;AARV;AAYM;EACE,gCAAA;AAVR;AAaM;EACE,6BAAA;AAXR;AAeI;EACE,YAAA;EACA,aAAA;AAbN;AAgBQ;EAAA,oBAAA;EAAA,qBAAA;EAAA,mBAAA;EAAA;AAAA;AAKA;;EAAA,oBAAA;EAAA,qBAAA;EAAA,sBAAA;EACA;AADA;AAGA;;EACE,WAAA;AAbV;AAkBQ;EAAA;AAAA;AAIA;EAAA;AAAA;AAIJ;EACE,YAAA;EACA,aAAA;AAlBN;AAqBQ;EAAA,oBAAA;EAAA,qBAAA;EAAA,mBAAA;EAAA;AAAA;AAKA;;EAAA,oBAAA;EAAA,qBAAA;EAAA,sBAAA;EACA;AADA;AAGA;;EACE,WAAA;AAlBV;AAuBQ;EAAA;AAAA;AAIA;EAAA;AAAA;;AAMR;EACE;uEAAA;EAEA;IACE,wBAAA;IACA,8BAAA;IACA,uBAAA;IACA,wBAAA,EAAA,uBAAA;IACA,iCAAA;EAxBF;EA2BA;IACE,mCAAA;IACA,2BAAA;IACA,yCAAA;IACA,uBAAA;IACA,yBAAA;IACA,8BAAA;IACA,yBAAA;IACA,qDAAA;EAzBF;EA4BA,0EAAA;EACA;IACE,0CAAA;IACA,2BAAA;EA1BF;AACF;AA8BA,iFAAA;AACA;EACE;IAYE,mFAAA;IAMA,yEAAA;EA5CF;EA2BE;;IAEE,wBAAA;EAzBJ;EA4BE;IACE,uBAAA;IACA,oCAAA;IACA,+BAAA;EA1BJ;EA8BE;IACE,wBAAA;IACA,iCAAA;EA5BJ;EAgCE;IACE,2BAAA;IACA,oBAAA;IACA,kBAAA;IACA,sBAAA;IACA,8BAAA;IACA,sBAAA;IACA,sDAAA;EA9BJ;AACF","sourcesContent":[".modal {\n  background: rgba(16, 16, 16, 0.8);\n  inset: 0;\n  z-index: 40;\n\n  .modal-container {\n    background: theme('colors.white');\n    border-radius: 12px;\n    z-index: 50;\n\n    .modal-content {\n      overflow: auto;\n    }\n\n    &.extra-large {\n      .modal-header {\n        padding: 10px;\n      }\n    }\n\n    &.large {\n      width: 832px;\n      height: 640px;\n\n      .modal-header,\n      .modal-footer,\n      .modal-content {\n        @apply px-12 py-6;\n      }\n\n      .modal-header {\n        border-bottom: 1px solid theme('colors.grey-10');\n      }\n\n      .modal-footer {\n        border-top: 1px solid theme('colors.grey-10');\n\n        @apply gap-4 justify-end;\n      }\n    }\n\n    &.medium {\n      width: 560px;\n      height: 684px;\n\n      .modal-content {\n        @apply px-8 pt-8 pb-5;\n      }\n\n      .modal-header,\n      .modal-footer {\n        @apply gap-4;\n        @apply p-8;\n\n        button {\n          flex: 1;\n        }\n      }\n\n      .modal-header {\n        border-bottom: 1px solid theme('colors.grey-10');\n      }\n\n      .modal-footer {\n        border-top: 1px solid theme('colors.grey-10');\n      }\n    }\n\n    &.regular {\n      width: 380px;\n      height: 442px;\n\n      .modal-content {\n        @apply px-6 pt-6 pb-5;\n      }\n\n      .modal-header,\n      .modal-footer {\n        @apply px-6 pb-6;\n        @apply gap-2;\n\n        button {\n          width: 100%;\n        }\n      }\n\n      .modal-header {\n        @apply pt-6;\n      }\n\n      .modal-footer {\n        @apply flex-col-reverse;\n      }\n    }\n\n    &.qrcode {\n      width: 640px;\n      height:532px;\n\n      .modal-content {\n        @apply px-6 pt-6 pb-5;\n      }\n\n      .modal-header,\n      .modal-footer {\n        @apply px-6 pb-6;\n        @apply gap-2;\n\n        button {\n          width: 100%;\n        }\n      }\n\n      .modal-header {\n        @apply pt-6;\n      }\n\n      .modal-footer {\n        @apply flex-col-reverse;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  /* Center modal on mobile with space around and rounded corners\n     Force a max width and max height so it never becomes full-bleed. */\n  .modal {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center;\n    padding: 20px !important; /* space around modal */\n    background: rgba(16,16,16,0.6);\n  }\n\n  .modal .modal-container {\n    width: calc(100% - 40px) !important;\n    max-width: 640px !important;\n    max-height: calc(100vh - 80px) !important;\n    height: auto !important;\n    margin: 0 auto !important;\n    border-radius: 12px !important;\n    overflow: auto !important;\n    box-shadow: 0 8px 32px rgba(0,0,0,0.12) !important;\n  }\n\n  /* Ensure modal header/footer and content fit inside the new constraints */\n  .modal .modal-content {\n    max-height: calc(100vh - 160px) !important;\n    overflow-y: auto !important;\n  }\n\n}\n\n/* Reduce internal padding on mobile modals to create a tighter, cleaner layout */\n@media (max-width: 768px) {\n  .modal .modal-container {\n    .modal-header,\n    .modal-footer {\n      padding: 12px !important;\n    }\n\n    .modal-content {\n      padding: 8px !important;\n      /* reserve space for sticky footer */\n      padding-bottom: 96px !important;\n    }\n\n    /* If content wrapper divs set padding elsewhere, ensure smaller padding here too */\n    .modal-content > div {\n      padding: 12px !important;\n      box-sizing: border-box !important;\n    }\n\n    /* Make footer sticky to avoid overlapping content when content scrolls */\n    .modal-footer {\n      position: sticky !important;\n      bottom: 0 !important;\n      left: 0 !important;\n      width: 100% !important;\n      background: theme('colors.white') !important;\n      z-index: 60 !important;\n      box-shadow: 0 -6px 16px rgba(0,0,0,0.06) !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
